import { Button, Modal } from '@mairistem/composants';
import React from 'react';
import useModalSuperUserValidation from '../../../../../hooks/useModalSuperUserValidation';
import type { BordereauWithState } from '../../../../../interfaces/pieces/TreeRow';

interface BordereauDeleteModalProps {
  onChange: VoidFunction;
  onClose: VoidFunction;
  visible: boolean;
  isSuperUser: boolean;
  bordereau: BordereauWithState;
}

const BordereauDeleteModal = ({
  onClose,
  onChange,
  visible,
  isSuperUser,
  bordereau,
}: BordereauDeleteModalProps) => {
  const handleClick = (): void => {
    onChange();
    onClose();
  };

  const { isValidated, validationComponent } = useModalSuperUserValidation();

  return (
    <Modal
      closeIcon
      open={visible}
      onClose={onClose}
      data-testid="bordereauDeleteModal"
    >
      <Modal.Header>
        Supprimer le bordereau n°
        {bordereau.numero}
      </Modal.Header>
      <Modal.Content>
        <p>La suppression de ce bordereau entraîne celle des écritures qui sont liées. Cette action est irrémédiable</p>
        {
          isSuperUser && validationComponent
        }
      </Modal.Content>
      <Modal.Actions>
        <Button
          onClick={onClose}
          data-testid="cancelDeleteModalBtn"
        >
          Annuler
        </Button>
        <Button
          primary
          onClick={handleClick}
          disabled={isSuperUser && !isValidated}
          data-testid="confirmDeleteModalBtn"
        >
          Supprimer
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default BordereauDeleteModal;
